// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1rCYD","search":"Settings_search__ejSls","filter":"Settings_filter__36rlk"};